import React, { Component } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.css';

import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { connect } from 'react-redux'
import * as act from "../Store/actions"
import * as com from "../Common.js"
import { withRouter } from "react-router-dom";

import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
const mapStateToProps = (state) => {
    return {
        hascoborrower: state.application.hascoborrower,
        cohabiting: state.application.cohabiting,
        application: state.application,
        property: state.application.property,
        selection: state.application.selection,
    }
}

const mapDispatchToProps = (dispatch) => ({

    changeBorrowerInfo: (event, who, verb) => {
        dispatch(act.ChangeBorrowerInfo(event.target.value, who, verb))
    },
    changeBorrowerInfoCheck: (event, who, verb) => {
        dispatch(act.ChangeBorrowerInfo(event.target.checked, who, verb))
    },
    changePhoneInfo: (input, who, verb) => {
        dispatch(act.ChangeBorrowerInfo(input, who, verb))
    },

    updatePreviousAddress: (event, who, verb, n) => {
        dispatch(act.UpdatePreviousAddress(event.target.value, who, verb, n))
    },
    addPreviousAddress: (event, who) => {
        dispatch(act.AddPreviousAddress(event.target.value, who,))
    },
    removePreviousAddress: (event, who, n) => {
        dispatch(act.RemovePreviousAddress(event.target.value, who, n))
    },
    clearPreviousAddress: (event, who) => {
        dispatch(act.ClearPreviousAddress(event.target.value, who))
    },
    changeMainProperty: (value, verb) => {
        dispatch(act.ChangeMainProperty(value, verb))
    },
    changeMainPropertyUnits: (event) => {
        dispatch(act.ChangeMainPropertyUnits(event.target.value))
    },
    changeMainPropertyYearBuilt: (event) => {
        dispatch(act.ChangeMainPropertyYearBuilt(event.target.value))
    },
    changeMainPropertyRefinanceYearAcquired: (event) => {
        dispatch(act.ChangeMainPropertyRefinanceYearAcquired(event))
    },
    changeMainPropertyRefinanceOriginalCost: (event) => {
        dispatch(act.ChangeMainPropertyRefinanceOriginalCost(event))
    },
    updateApplicationAttribute: (input, verb) => {
        dispatch(act.UpdateApplicationAttribute(input, verb))
    },
    updateSelectField: (input, verb) => {
        dispatch(act.UpdateSelectField(input, verb))
    },
    addSelectedLoanPrepaid: (service, chargename, period) => {
        dispatch(act.AddSelectedLoanPrepaid(service, chargename, period))
    },
    updatePaymentPeriod: (name, service, period) => {
        dispatch(act.UpdatePaymentPeriod(name, service, period))
    },
    updatePaymentAmount: (name, service, amount) => {
        dispatch(act.UpdatePaymentAmount(name, service, amount))
    },
    updatePrepaidDefault: (name, service, period, prepaidperiods, amount) => {
        dispatch(act.UpdatePrepaidDefault(name, service, period, prepaidperiods, amount))
    },
    addSelectedLoanEstimatedClosingCosts: (cc) => {
        dispatch(act.AddSelectedLoanEstimatedClosingCosts(cc))
    },


});


const formatAmount = (amountStr) =>{
    let amount = Number(amountStr)
    if(amount === 0){
      return '0.00';
    }

    // add $ sign
    // 增加千分位分隔符
    return amount > 0 ? `$${amount.toLocaleString()}` : '-$' + Math.abs(amount).toLocaleString();
}

class LoanEstimate extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ltv: 0,
            cltv: 0,
            hcltv: 0,
        }
        this.card = this.props.card
        //updatePrepaidDefault: (name, period, prepaidperiods, amount)
        let rate = this.props.card.base_rate / 100 / 360 * this.getLoanSize()
        let name = "Prepaid Interest"
        let service = "prepaids"
        // this.closingCostFinanced = this.props.filterParams.compensationType === 'lender_paid' ?  0 : 0 - this.props.card.lender_credit
        let cc = this.getMergedDetail()
        this.closingCostFinanced = 0
        if (this.props.filterParams.upFrontMIP_Financed && cc.canNotShopServices.find(item => item.serviceName === "Upfront Mortgage Insurance Premium")) {
            this.closingCostFinanced = 0 - (cc.canNotShopServices.find(item => item.serviceName === "Upfront Mortgage Insurance Premium").estimateAmount || 0)
        }
        let days = this.props.card.prepaiddays
        if ("undefined" === typeof days)
            days = 15
        // if ("undefined" !== typeof this.card.lockstatus) {
            // if (!this.hasPrepaidInterest()) {

            //     this.props.addSelectedLoanEstimatedClosingCosts(this.props.application.selection.estimatedclosingcosts)

            //     this.props.addSelectedLoanPrepaid(service, name, "daily")

            //     this.props.updatePaymentPeriod(name, service, days)

            //     this.props.updatePaymentAmount(name, service, rate)
            // } else {
            //     this.props.updatePrepaidDefault(name, service, "daily", days, rate)

            // }
        // } else {
            // this.props.updatePrepaidDefault(name, service, "daily", days, rate)

        // }
    }
    getMergedDetail = () => {
        // 取出两个来源
        const cardDetail = this.card.closing_costs_detail || this.card.estimatedclosingcosts.closingCostsDetail || {};
        const propDetail = this.props.closingCostsDetail || {};
        // 需要合并的所有字段
        const fields = [
            'canNotShopServices',
            'canShopServices',
            'taxesAndOtherGovernmentFees',
            'originationCharges',
            'prepaids',
            'initialEscrowPaymentsAtClosing',
            'other'
        ];
    
        const isValidCost = item => item && typeof item.serviceName === 'string' && item.serviceName.trim() !== '';
        // 合并逻辑：同名字段合并为一个数组，并兼容历史空名称配置
        const merged = {};
        fields.forEach(field => {
            const arr1 = Array.isArray(cardDetail[field]) ? cardDetail[field] : [];
            const arr2 = Array.isArray(propDetail[field]) ? propDetail[field] : [];
            merged[field] = [...arr1, ...arr2].filter(isValidCost);
        });

        // console.log('detail merged: ', merged)
    
        return merged;
    }
    hasPrepaidInterest = () => {
        let cc = this.props.application.selection.estimatedclosingcosts
        if (null != this.card.estimatedclosingcosts)
            cc = this.card.estimatedclosingcosts

        let ret = false
        Object.keys(cc.prepaids).forEach(function (key) {

            if (cc.prepaids[key].paymentname === "Prepaid Interest" && cc.prepaids[key].amount !== 0) {
                ret = true
            }
        });
        return ret
    }


    canShopFor = () => {
        let cc = this.getMergedDetail()
        if (!cc) return null;
        if (!Array.isArray(cc.canShopServices)) cc.canShopServices = [];
    
        let total = 0;
        cc.canShopServices.forEach(function (item) {
            total += parseFloat(item.estimateAmount);
        });
        this.canShopForFee = total;
    
        let process = (item, index) => {
            return <Row xs="auto" key={"canshop" + index}>
                <Col>{item.serviceName}</Col>
                <Col xs="auto">${com.commaizeFloat(item.estimateAmount.toFixed(2))}</Col>
            </Row>
        };
    
        return (
            <div>
                <Row>
                    <Col xs="auto" className="roundedtab ml-2 border-bottom ">C. Services you can shop for:</Col>
                    <Col className="tabajacent"></Col>
                    <Col xs="auto" className="tabajacent">
                        ${com.commaizeFloat(total.toFixed(2))}
                    </Col>
                </Row>
                {cc.canShopServices.map(process)}
                <div>&nbsp;</div>
            </div>
        );
    }

    cantShopFor = () => {
        let cc = this.getMergedDetail()
        if (!cc) return null;
        if (!Array.isArray(cc.canNotShopServices)) cc.canNotShopServices = [];

        let total = 0
        cc.canNotShopServices.forEach(function (item) {
            total += parseFloat(item.estimateAmount)
        });
        this.cantShopForFee = total

        let process = (item, index) => {
            return <Row xs="auto" key={"canshopfor" + index}>
                <Col>{item.serviceName}</Col>
                <Col xs="auto">${com.commaizeFloat(item.estimateAmount.toFixed(2))}</Col>
            </Row>
        }

        return (
            <div>
                <Row >
                    <Col xs="auto" className="roundedtab ml-2 border-bottom ">B. Services you can't shop for:
                    </Col>
                    <Col className="tabajacent"></Col>
                    <Col xs="auto" className="tabajacent">
                        ${com.commaizeFloat(total.toFixed(2))}
                    </Col>
                </Row>
                {cc.canNotShopServices.map(process)}
                <div>&nbsp;</div>
            </div>
        )
    }
    totalLoanCost = () => {
        return (
            <div>
                <Row >
                    <Col xs="auto" className="roundedtab ml-2 border-bottom ">D. Total Loan Costs (A+B+C):
                    </Col>
                    <Col className="tabajacent"></Col>
                    <Col xs="auto" className="tabajacent">
                        ${com.commaizeFloat((this.cantShopForFee + this.canShopForFee + this.originationFees).toFixed(2))}
                    </Col>
                </Row>

                <div>&nbsp;</div>
            </div>
        )

    }
    otherTotal = () => {
        return (
            <div>
                <Row >
                    <Col xs="auto" className="roundedtab ml-2 border-bottom ">I. Total Other Costs (E + F + G + H):
                    </Col>
                    <Col className="tabajacent"></Col>
                    <Col xs="auto" className="tabajacent">
                        ${com.commaizeFloat((this.taxFees + this.prepaidFees + this.initialEscrowAtClosingFee +
                            this.otherFees).toFixed(2)
                        )}
                    </Col>
                </Row>

                <div>&nbsp;</div>
            </div>
        )
    }

    totalClosing = () => {

        let DI = this.cantShopForFee + this.canShopForFee + this.originationFees + this.taxFees + this.prepaidFees + this.initialEscrowAtClosingFee +
            this.otherFees

        this.totalclosingcosts = this.card.closing_cost

        let remaining_credits = 0
        if (this.totalclosingcosts < 0) {
            remaining_credits = this.totalclosingcosts
        }

        return (
            <div>
                <Row >
                    <Col xs="auto" className="roundedtab ml-2 border-bottom ">J. Total Closing Costs:
                    </Col>
                    <Col className="tabajacent"></Col>
                    <Col xs="auto" className="tabajacent">
                        {/* ${com.commaizeFloat(this.totalclosingcosts.toFixed(2))} */}
                        {formatAmount(this.totalclosingcosts.toFixed(2))}
                    </Col>
                </Row>
                <Row>
                    <Col>D + I
                    </Col>
                    <Col xs="auto" >
                        ${com.commaizeFloat(DI.toFixed(2))}
                    </Col>
                </Row>
                {Number(this.props.card.lender_credit) < 0 ?
                    <Row>
                        <Col>Lender Credit</Col>
                        <Col xs="auto">
                            {formatAmount(Number(this.props.card.lender_credit).toFixed(2))}
                        </Col>
                    </Row>
                    : ""}
                {remaining_credits < 0 ?
                    <Row>
                        <Col>Remaining Lender Credit
                        </Col>
                        <Col xs="auto" >
                            {/* -${com.commaizeFloat(-remaining_credits.toFixed(2))} */}
                            {formatAmount(Number(remaining_credits).toFixed(2))}
                        </Col>
                    </Row>

                    : ""}
                <div>&nbsp;</div>
            </div>
        )
    }

    taxes = () => {
        let cc = this.getMergedDetail()
        if (!cc) return null;
        if (!Array.isArray(cc.taxesAndOtherGovernmentFees)) cc.taxesAndOtherGovernmentFees = [];
    
        let total = 0;
        cc.taxesAndOtherGovernmentFees.forEach(item => {
            total += parseFloat(item.estimateAmount);
        });
        this.taxFees = total;
    
        let process = (item, index) => (
            <Row key={"taxfee" + index}>
                <Col>{item.serviceName}</Col>
                <Col xs="auto">${com.commaizeFloat(item.estimateAmount.toFixed(2))}</Col>
            </Row>
        );
    
        return (
            <div>
                <Row>
                    <Col xs="auto" className="roundedtab ml-2 border-bottom ">E. Taxes and other government fees:</Col>
                    <Col className="tabajacent"></Col>
                    <Col xs="auto" className="tabajacent">
                        ${com.commaizeFloat(total.toFixed(2))}
                    </Col>
                </Row>
                {cc.taxesAndOtherGovernmentFees.map(process)}
                <div>&nbsp;</div>
            </div>
        );
    }

    originationCharges = () => {
        const detail = this.getMergedDetail();
        const originationCharges = detail.originationCharges || [];
    
        let total = 0;
        originationCharges.forEach(item => {
            total += parseFloat(item.estimateAmount);
        });
        this.originationFees = total;
    
        let process = (item, index) => (
            <Row key={item.serviceName + index}>
                <Col>{item.serviceName}</Col>
                <Col xs="auto">${com.commaizeFloat(item.estimateAmount.toFixed(2))}</Col>
            </Row>
        );
    
        return (
            <div>
                <Row>
                    <Col xs="auto" className="roundedtab ml-2 border-bottom">A. Origination charges:</Col>
                    <Col className="tabajacent"></Col>
                    <Col xs="auto" className="tabajacent">
                        ${com.commaizeFloat(this.originationFees.toFixed(2))}
                    </Col>
                </Row>
                {originationCharges.map(process)}
                <div>&nbsp;</div>
            </div>
        );
    }
    prepaids = () => {
        let cc = this.getMergedDetail();
        if (!cc) return null;
        if (!Array.isArray(cc.prepaids)) cc.prepaids = [];
    
        let total = 0;
        cc.prepaids.forEach(item => {
            total += parseFloat(item.estimateAmount);
        });
    
        this.prepaidFees = total;
    
        let displayPrepaid = (item, index) => (
            <Row key={item.serviceName + index}>
                <Col>{item.serviceName}</Col>
                <Col xs="auto">${com.commaizeFloat(item.estimateAmount.toFixed(2))}</Col>
            </Row>
        );
    
        return (
            <div>
                <Row>
                    <Col xs="auto" className="roundedtab ml-2 border-bottom ">F. Prepaids:</Col>
                    <Col className="tabajacent"></Col>
                    <Col xs="auto" className="tabajacent">
                        ${com.commaizeFloat(total.toFixed(2))}
                    </Col>
                </Row>
                {cc.prepaids.map(displayPrepaid)}
                <div>&nbsp;</div>
            </div>
        );
    }
    initialescrowatclosing = () => {
        let cc = this.getMergedDetail();
        if (!cc) return null;
        if (!Array.isArray(cc.initialEscrowPaymentsAtClosing)) cc.initialEscrowPaymentsAtClosing = [];
    
        let total = 0;
        cc.initialEscrowPaymentsAtClosing.forEach(item => {
            total += parseFloat(item.estimateAmount.toFixed(2));
        });
    
        this.initialEscrowAtClosingFee = total;
    
        let displayPrepaid = (item, index) => (
            <Row key={item.serviceName + index}>
                <Col>{item.serviceName}</Col>
                <Col xs="auto">${com.commaizeFloat(item.estimateAmount.toFixed(2))}</Col>
            </Row>
        );
    
        return (
            <div>
                <Row>
                    <Col xs="auto" className="roundedtab ml-2 border-bottom ">G. Initial Escrow Payments at Closing:</Col>
                    <Col className="tabajacent"></Col>
                    <Col xs="auto" className="tabajacent">
                        ${com.commaizeFloat(total.toFixed(2))}
                    </Col>
                </Row>
                {cc.initialEscrowPaymentsAtClosing.map(displayPrepaid)}
                <div>&nbsp;</div>
            </div>
        );
    }
    other = () => {
        let cc = this.getMergedDetail();
        if (!cc) return null;
        if (!Array.isArray(cc.other)) cc.other = [];
    
        let total = 0;
        cc.other.forEach(item => {
            total += parseFloat(item.estimateAmount);
        });
        this.otherFees = total;
    
        let process = (item, index) => (
            <Row xs="auto" key={item.serviceName + index}>
                <Col>{item.serviceName}</Col>
                <Col xs="auto">${com.commaizeFloat(item.estimateAmount.toFixed(2))}</Col>
            </Row>
        );
    
        return (
            <div>
                <Row>
                    <Col xs="auto" className="roundedtab ml-2 border-bottom ">H. Other:</Col>
                    <Col className="tabajacent "></Col>
                    <Col xs="auto" className="tabajacent ">
                        ${com.commaizeFloat(total.toFixed(2))}
                    </Col>
                </Row>
                {cc.other.map(process)}
                <div>&nbsp;</div>
            </div>
        );
    }
    cashtoclose = () => {
        const toAmount = value => {
            const amount = Number(value)
            return Number.isFinite(amount) ? amount : 0
        }

        const filterParams = this.props.filterParams || {}
        const pricingRequest = filterParams.pricingRequest || {}
        const loanProgram = String(filterParams.loanProgram || pricingRequest.loanProgram || '').toLowerCase()
        const lienPosition = String(filterParams.lienPosition || pricingRequest.lienPosition || '').toLowerCase()
        const isSecondLien = ['heloc', 'heloan', 'secondmortgage'].includes(loanProgram) ||
            ['second', '2nd'].includes(lienPosition)

        let cc = this.props.application.selection.estimatedclosingcosts || {}
        if (this.card.estimatedclosingcosts && typeof this.card.estimatedclosingcosts === 'object')
            cc = this.card.estimatedclosingcosts
        let getDownpayment = () => {

            // A second-lien HELOC/HELOAN may use Purchase as its purpose, but
            // it has no first-lien purchase down payment in this fee sheet.
            if (isSecondLien) {
                return 0
            }

            if ("undefined" === typeof this.props.card.downpayment) {
                // let customerfunds = 0

                // switch (this.props.property.purpose) {
                //     case "purchase":
                //         customerfunds = this.props.selection.downpayment
                //         break;
                //     case "refinance":
                //         customerfunds = this.props.selection.paydown
                //         break;
                //     case "cashoutrefinance":
                //         customerfunds = this.props.selection.cashout
                //         break;
                //     default:
                //         alert("should not see this!")
                //         break;
                // }
                // return customerfunds
                // console.log('-----------', this.props)
                const purpose = filterParams.purpose || filterParams.loanPurpose
                if(purpose === 'Purchase'){
                    return toAmount(filterParams.downPayment) // this.props.selection.downpayment
                }else{
                    return 0
                }
            }

            return toAmount(this.props.card.downpayment) + toAmount(this.props.card.paydown)
        }
        const downpayment = getDownpayment()
        const deposit = toAmount(cc.deposit)
        const fundsForBorrower = toAmount(cc.fundsforborrower)
        const sellerCredits = toAmount(cc.sellerscredits)
        const otherCredits = toAmount(cc.adjustmentsothercredits)

        this.finalCashToClose = toAmount(this.totalclosingcosts) + toAmount(this.closingCostFinanced) + downpayment +
            deposit + fundsForBorrower + sellerCredits + otherCredits

        return (
            <div>
                <Row>
                    <Col xs="auto" className="roundedtab ml-2 border-bottom ">Calculating Cash to Close:
                    </Col>
                    <Col className="tabajacent "></Col>
                </Row>
                <Row>
                    <Col>Total closing costs (J)
                    </Col>
                    <Col xs="auto" >
                        {/* ${com.commaizeFloat(this.totalclosingcosts.toFixed(2))} */}
                        {formatAmount(this.totalclosingcosts.toFixed(2))}
                    </Col>
                </Row>
                <Row>
                    <Col>Closing costs financed
                    </Col>
                    <Col xs="auto" >
                        {/* ${com.commaizeFloat(this.closingCostFinanced.toFixed(2))} */}
                        {formatAmount(this.closingCostFinanced.toFixed(2))}
                    </Col>
                </Row>
                <Row>
                    <Col>Downpayment/Funds from borrower
                    </Col>
                    <Col xs="auto" >
                        ${com.commaizeFloat(downpayment.toFixed(2))}
                    </Col>
                </Row>
                <Row>
                    <Col>Deposit
                    </Col>
                    <Col xs="auto" >
                        ${com.commaizeFloat(deposit.toFixed(2))}
                    </Col>
                </Row>
                <Row>
                    <Col>Funds for Borrower
                    </Col>
                    <Col xs="auto" >
                        ${com.commaizeFloat(fundsForBorrower.toFixed(2))}
                    </Col>
                </Row>
                <Row>
                    <Col>Seller's Credits
                    </Col>
                    <Col xs="auto" >
                        ${com.commaizeFloat(sellerCredits.toFixed(2))}
                    </Col>
                </Row>
                <Row>
                    <Col>Adjustments/Other credits
                    </Col>
                    <Col xs="auto" >
                        ${com.commaizeFloat(otherCredits.toFixed(2))}
                    </Col>
                </Row>
                <div>&nbsp;</div>
                <Row className="border-bottom border-dark">
                    <Col>
                    </Col>
                    <Col>
                    </Col>
                </Row>
                <Row>
                    <Col style={{ fontWeight: 'bold' }}>
                        Cash to close:
                    </Col>
                    <Col xs="auto" style={{ fontWeight: 'bold' }}>
                        {/* ${com.commaizeFloat(this.finalCashToClose.toFixed(2))} */}
                        {formatAmount(this.finalCashToClose.toFixed(2))}
                    </Col>
                </Row>
            </div>
        )
    }
    getLoanSize = () => {
        let card = this.props.card
        if ("undefined" !== typeof (card.loansize))
            return parseFloat(card.loansize)

        return parseFloat(this.props.application.selection.loansize)
    }
    render = () => {
        return <div className="py-2 px-0">
            <Row>
                <Col style={{ width: '70%' }}>
                    <h2 className="heading mb-4">Closing costs are what you pay for points, fees and services to close your loan.</h2>
                </Col>
            </Row>
            <Row>
                <Col xs="auto" className="px-0 mx-0">
                    {this.originationCharges()}
                    {this.cantShopFor()}
                    {this.canShopFor()}
                    {this.totalLoanCost()}
                    {this.taxes()}
                    {this.prepaids()}
                    {this.initialescrowatclosing()}
                    {this.other()}
                    {this.otherTotal()}
                    {this.totalClosing()}
                    {this.cashtoclose()}

                </Col>
                <Col xs="auto" className="p-5 ">
                <div className="disclaimer-text">
                    Disclaimer: The closing costs provided are estimates only and are subject to change. Actual costs may vary based on final lender fees, third-party charges, and other factors.
                </div>
                </Col>
            </Row>
        </div>
    }
}
LoanEstimate = withRouter(connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(LoanEstimate))
class Details extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }
    componentDidMount() {

    }

    componentWillUnmount() { }


    handleSubmit = e => {
        return true
    }


    render() {

        return (
            <Tabs className="border  border-top border-left border-right text-dard" transition={false}
                id="detalstabs" unmountOnExit={true} >
                <Tab eventKey="upfrontfees" title="Closing Cost Details" className="text-dark border" >
                    <LoanEstimate card={this.props.card} closingCostsDetail={this.props.closingCostsDetail} filterParams={this.props.filterParams} />
                </Tab>
                {/* <Tab eventKey="loandetails" title="Overview" className="text-dark border" >
                    <LoanDetails card={this.props.card} />
                </Tab> */}
            </Tabs>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Details)
